module.exports = __webpack_public_path__ + "img/lianyungang_s.31f5d54.png";